import { useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type BannerContext } from '@/infra/services/new-tail/model';
import { useUserResources } from '@/presenters/hooks/user';
import { useGlobalStore } from '@/presenters/store/global';

interface UseBannersAdsProps {
  context: BannerContext;
  id: string;
}

const useBannersAds = (props: Readonly<UseBannersAdsProps>) => {
  const { context, id } = props;

  const {
    server: { device: serverDevice, isOnMobileApp },
  } = useGlobalStore((state) => state);

  const { data: userTrackingId } = useUserResources((data) => data.trackingId);
  const { data: userId } = useUserResources((data) => data.id);

  const device = isOnMobileApp ? 'app' : serverDevice;

  const query = useQuery(
    ['banners-ads', userTrackingId, context, id, device],
    async () => {
      if (!userTrackingId) return;

      return Services.NewTail.getBannersAds({
        context,
        sessionId: userTrackingId,
        userId,
        device,
      });
    },
    {
      enabled: Boolean(userTrackingId),
    }
  );

  return query;
};

export default useBannersAds;
